import React, { Component, type JSX } from 'react';
import { events } from '../../util/Events';
import { FaqMobile } from './FaqMobile';
import { FaqDesktop } from './FaqDesktop';
import 'devbridge-autocomplete';
import { FaqResponse } from './Faq.model';

type Categories = FaqResponse['categories'];
type Category = Categories[0];
type Question = Category['subjects'][0];

export const EVENT_FAQ_TOGGLE_CATEGORY: string = 'toggleCategory';
export type FaqToggleCategoryEvent = number;
export const EVENT_FAQ_TOGGLE_QUESTION: string = 'toggleQuestion';
export type FaqToggleQuestionEvent = number;

interface ComponentProps {
  categories: Categories;
}

interface ComponentState {
  activeCategory: number;
  activeQuestions: number[];
}

export class FaqComponent extends Component<ComponentProps, ComponentState> {

  constructor(props: ComponentProps) {
    super(props);

    if ($(window).width() < 768) {
      this.state = {
        activeCategory: -1,
        activeQuestions: [],
      };
    } else {
      this.state = {
        activeCategory: 0,
        activeQuestions: [],
      };
    }

    // events triggered by child components
    events.on(EVENT_FAQ_TOGGLE_CATEGORY, (index: FaqToggleCategoryEvent) => {
      this.setCategory(index);
    });

    events.on(EVENT_FAQ_TOGGLE_QUESTION, (index: FaqToggleQuestionEvent) => {
      this.toggleQuestion(index);
    });
  }

  /**
   * Initialize jquery autocomplete to autocomplete
   * search field header.
   */
  public autoComplete(results: AutocompleteSuggestion[]): void {
    const options: JQueryAutocompleteOptions = {
      lookup: results,
      minChars: 1,
      zIndex: 1,
      onSelect: /* istanbul ignore next */ (e: AutocompleteSuggestion): false => this.onClickAutocompleteItem(e),
    };

    $('#faq-search-field').autocomplete(options);
  }

  /**
   * Opens the question
   */
  public onClickAutocompleteItem(event: AutocompleteSuggestion): false {
    $('html, body').animate({
      scrollTop: 300,
    }, 500);

    this.setState({
      activeCategory: event.data.category,
      activeQuestions: [event.data.question],
    });

    return false;
  }

  /**
   * Toggle a category of question and clear active questions.
   */
  public setCategory(key: FaqToggleCategoryEvent): void {
    if ((this.state.activeCategory === key) && ($(window).width() < 768)) {
      this.setState({
        activeCategory: -1,
        activeQuestions: [],
      });
    } else {
      this.setState({
        activeCategory: key,
        activeQuestions: [],
      });
    }
  }


  /**
   * Adds or removes a active question from the list.
   */
  public toggleQuestion(index: FaqToggleQuestionEvent): void {
    let activeQuestions = this.state.activeQuestions;
    let indexClicked = activeQuestions.indexOf(index);

    // if the item is not already in the array add it otherwise remove it
    if (indexClicked === -1) {
      activeQuestions.push(index);
    } else {
      activeQuestions.splice(indexClicked, 1);
    }

    this.setState({
      activeQuestions: activeQuestions,
    });
  }

  /**
   * Converts the results from the backend to an
   * array for the autocomplete search.
   */
  public getAutocompleteData(categories: Categories): AutocompleteSuggestion[] {
    let searchData: AutocompleteSuggestion[] = [];

    categories.forEach((category: Category, catIndex: number) => {
      category.subjects.forEach((question: Question, index: number) => {
        searchData.push({
          data: {
            category: catIndex,
            question: index,
          },
          value: question.question,
        });
      });
    });

    return searchData;
  }

  /**
   * Renders either the desktop or the mobile faq.
   */
  public render(): JSX.Element {
    const categories = this.props.categories;
    const activeCategory = this.state.activeCategory;
    const activeQuestions = this.state.activeQuestions;
    const searchData = this.getAutocompleteData(categories);

    this.autoComplete(searchData);

    if ($(window).width() < 768) {
      return (<FaqMobile
        categories={categories}
        activeCategory={activeCategory}
        activeQuestions={activeQuestions}/>);
    }
    return (<FaqDesktop
      categories={categories}
      activeCategory={activeCategory}
      activeQuestions={activeQuestions}/>);

  }
}
